module.exports = __webpack_public_path__ + "img/art_3_8.0bc3e4a4.png";